import { render, staticRenderFns } from "./AddRecipients.vue?vue&type=template&id=4f11ec08&scoped=true&lang=pug"
import script from "./AddRecipients.vue?vue&type=script&lang=js"
export * from "./AddRecipients.vue?vue&type=script&lang=js"
import style0 from "./AddRecipients.vue?vue&type=style&index=0&id=4f11ec08&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f11ec08",
  null
  
)

export default component.exports